import { useState, useEffect, useRef } from 'react';

export function PageTurn({ page, children }) {
  const [cls, setCls] = useState('');
  const prevPage = useRef(page);
  const timerRef = useRef(null);

  useEffect(() => {
    if (page === prevPage.current) return;
    const fwd = page > prevPage.current;
    prevPage.current = page;
    clearTimeout(timerRef.current);
    setCls(fwd ? 'pt-flip-fwd' : 'pt-flip-bwd');
    timerRef.current = setTimeout(() => setCls(''), 440);
    return () => clearTimeout(timerRef.current);
  }, [page]);

  return <div className={`pt-wrap${cls ? ` ${cls}` : ''}`}>{children}</div>;
}

export function Paginate({ page, total, pageSize, onPage }) {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginTop: 20, padding: '12px 0' }}>
      <button
        className="btn"
        style={{ borderColor: page === 0 ? 'var(--brd2)' : 'var(--j1)', color: page === 0 ? 'var(--txt3)' : 'var(--j1)', padding: '6px 14px', fontSize: 11, fontFamily: 'Share Tech Mono', letterSpacing: 1 }}
        disabled={page === 0}
        onClick={() => onPage(page - 1)}
      >
        ← PREV
      </button>
      <div style={{ fontFamily: 'Share Tech Mono', fontSize: 11, color: 'var(--txt2)', textAlign: 'center', minWidth: 140 }}>
        <span style={{ color: 'var(--j1)', fontFamily: 'Orbitron', fontWeight: 700 }}>{page + 1}</span>
        <span style={{ color: 'var(--txt3)' }}> / {totalPages}</span>
        <div style={{ fontSize: 9, color: 'var(--txt3)', marginTop: 2 }}>{start}–{end} of {total}</div>
      </div>
      <button
        className="btn"
        style={{ borderColor: page >= totalPages - 1 ? 'var(--brd2)' : 'var(--j1)', color: page >= totalPages - 1 ? 'var(--txt3)' : 'var(--j1)', padding: '6px 14px', fontSize: 11, fontFamily: 'Share Tech Mono', letterSpacing: 1 }}
        disabled={page >= totalPages - 1}
        onClick={() => onPage(page + 1)}
      >
        NEXT →
      </button>
    </div>
  );
}
